import {
  Checkbox,
  CheckboxProps,
  createStyles,
  FormControlLabel,
  WithStyles,
  withStyles,
} from '@freighthub/silhouette-core'
import cn from 'classnames'
import { Component, ReactNode, SyntheticEvent } from 'react'

const jssCheckboxRow = () =>
  createStyles({
    root: {},
    negativeMarginTop: {
      marginTop: '-14px',
    },
    label: {
      marginLeft: '6px',
    },
    help: {
      marginTop: '-10px',
      marginLeft: '40px',
    },
    children: {
      marginLeft: '40px',
    },
  })

interface IQRCheckboxRowProps extends Omit<CheckboxProps, 'classes'>, WithStyles<typeof jssCheckboxRow, false> {
  checked: boolean
  children?: ReactNode
  help?: ReactNode
  label?: ReactNode
  onCheck: (checked: boolean) => void
  required?: boolean
  validationCustomMessage?: string
  negativeMarginTop?: boolean
}

class LeanQRCheckboxRow extends Component<IQRCheckboxRowProps> {
  checkBoxElement?: HTMLInputElement

  componentDidUpdate() {
    const { checkBoxElement } = this

    if (checkBoxElement) {
      checkBoxElement.setCustomValidity('')
      checkBoxElement.checkValidity()
    }
  }

  handleCheck = (checked: boolean) => {
    const { onCheck } = this.props
    onCheck && onCheck(checked)
  }

  handleInvalid = (event: SyntheticEvent<HTMLElement>) => {
    this.checkBoxElement = event.target as HTMLInputElement
    this.checkBoxElement.setCustomValidity(this.props.validationCustomMessage || '')
  }

  render() {
    const {
      checked,
      children,
      help,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      onCheck,
      required,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      validationCustomMessage,
      label,
      classes,
      negativeMarginTop,
      ...rest
    } = this.props

    return (
      <div
        className={cn({
          [classes.negativeMarginTop]: negativeMarginTop,
        })}
      >
        <FormControlLabel
          label={label}
          checked={checked}
          // @ts-expect-error TS(2345) FIXME: Argument of type 'boolean | undefined' is not assi... Remove this comment to see the full error message
          onChange={(e) => this.handleCheck(e.target.checked)}
          classes={{ label: classes.label }}
          control={<Checkbox {...rest} color="primary" onInvalid={this.handleInvalid} required={required} />}
        />

        <div className={classes.help}>{help}</div>
        {checked && children && <div className={classes.children}>{children}</div>}
      </div>
    )
  }
}

export const QRCheckboxRow = withStyles(jssCheckboxRow)(LeanQRCheckboxRow)
